/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import axios from "axios";
import { AppThunk } from "../../../config/store";
import { AccountAction } from "./slices";
import { settingAPI } from "../../../config/api";

export const getLanguages =
  (code?: string): AppThunk =>
  async (dispatch) => {
    try {
      const composedUrl = `${settingAPI.GET_LANGUAGES}`;
      dispatch(AccountAction.getLanguagesStart());
      const response = await axios.get(composedUrl, {
        headers: code
          ? {
              "Accept-Language": code as string,
            }
          : undefined,
      });
      dispatch(AccountAction.getLanguagesSuccess(response.data.content));
    } catch (err) {
      dispatch(AccountAction.getLanguagesFailed());
    }
  };

export const setLanguageDefault =
  (code: string): AppThunk =>
  async (dispatch) => {
    try {
      const composedUrl = `${settingAPI.MAKE_LANGUAGE_DEFAULT(code)}`;
      dispatch(AccountAction.setLanguageDefaultStart());
      await axios.put(composedUrl);
      dispatch(AccountAction.setLanguageDefaultSuccess());
    } catch (err) {
      dispatch(AccountAction.setLanguageDefaultFailed());
    }
  };

export const getDefaultLanguageSetting = (): AppThunk => async (dispatch) => {
  try {
    const composedUrl = `${settingAPI.GET_DEFAULT_LANGUAGE_SETTING}`;
    dispatch(AccountAction.getDefaultLanguageSettingStart());
    const response = await axios.get(composedUrl);
    dispatch(
      AccountAction.getDefaultLanguageSettingSuccess(
        response.data as { code: string; name: string }
      )
    );
  } catch (err) {
    dispatch(AccountAction.getDefaultLanguageSettingFailed());
  }
};
